module.exports = __webpack_public_path__ + "img/chapter__2_image_6.43950cdc.jpg";